import React from "react";
import { MonthSelectionSheetProps } from "../../../../types/IMultiLocationQuoteMobile";

const MonthSelectionSheet: React.FC<MonthSelectionSheetProps> = ({
  open,
  months,
  selectedMonth,
  setSelectedMonth,
  onClose,
}) => {
  if (!open) {
    return null;
  }

  return (
    <div
      className="modal-bottom-sheet-overlay"
      onClick={(e) => {
        if (e.target === e.currentTarget) onClose();
      }}
      role="button"
      tabIndex={0}
      onKeyDown={(e) => {
        if (e.key === "Escape" || e.key === "Enter") onClose();
      }}
    >
      <div
        role="dialog"
        aria-modal="true"
        tabIndex={-1}
        className="modal-bottom-sheet-content"
      >
        <div className="modal-bottom-sheet-title">Select Month</div>
        <div className="month-scroll-container">
          {months.map((m) => (
            <button
              key={m.value}
              type="button"
              className={`month-chip ${m.value === selectedMonth ? "active" : ""}`}
              onClick={() => {
                if (setSelectedMonth) {
                  setSelectedMonth(m.value);
                }
                onClose();
              }}
            >
              {m.display}
            </button>
          ))}
        </div>
      </div>
    </div>
  );
};

export default MonthSelectionSheet;
